<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import MdmMainTable from "@/components/mdm/MdmMainTable.vue";
import MdmApprovalTable from "@/components/mdm/MdmApprovalTable.vue";
import MdmSettingsSection from "@/components/mdm/MdmSettingsSection.vue";
import { usePermissions } from "@/composables/usePermissions";

export default {
    page: {
        title: "MDM Device List",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
        MdmMainTable,
        MdmApprovalTable,
        MdmSettingsSection
    },
    setup() {
        const { canReadMdm, canApproveMdm, canRequestMdm, canExportMdm } = usePermissions();
        return { canReadMdm, canApproveMdm, canRequestMdm, canExportMdm };
    },
    data() {
        return {
            title: "MDM Device List",
            items: [
                { text: "Device Management", href: "/" },
                { text: "MDM Device List", active: true },
            ],
            currentTab: 'mdm',
        };
    },
    methods: {
        changeTab(tab) {
            this.currentTab = tab;
        },
    },
    mounted() {

        const { type } = this.$route.query;
        if (type) {
            const typeMap = {
                1: 'warning',
                2: 'locked',
                3: 'unlocked'
            };
            if (typeMap[type]) {
                this.currentTab = typeMap[type];
            }
        }
    }
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
        <div class="col-lg-12">
            <div class="card border-0 shadow-none mb-3">
                <div class="card-body p-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                        <!-- Navigation Tabs -->
                        <ul class="nav nav-tabs nav-tabs-custom nav-success border-bottom-0" role="tablist">
                            <li v-if="canReadMdm" class="nav-item">
                                <a class="nav-link" :class="{active: currentTab === 'mdm'}" @click="changeTab('mdm')" href="javascript:void(0);" role="tab">
                                    Enrolled Devices
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{active: currentTab === 'warning'}" @click="changeTab('warning')" href="javascript:void(0);" role="tab">
                                    Send Warning
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{active: currentTab === 'locked'}" @click="changeTab('locked')" href="javascript:void(0);" role="tab">
                                    Enable Lost Mode
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{active: currentTab === 'unlocked'}" @click="changeTab('unlocked')" href="javascript:void(0);" role="tab">
                                    Disable Lost Mode
                                </a>
                            </li>
                            <!-- Approval Settings Tab (Approver Only) -->
                            <li v-if="canApproveMdm" class="nav-item">
                                <a class="nav-link" :class="{active: currentTab === 'settings'}" @click="changeTab('settings')" href="javascript:void(0);" role="tab">
                                    <i class="ri-settings-4-line me-1 align-bottom"></i> Message Template
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Tab Content Area -->
    <div class="tab-content">
        <!-- 1. MDM Inventory (Master List) -->
        <div v-if="currentTab === 'mdm' && canReadMdm" class="animated fadeIn">
             <MdmMainTable :can-export="canExportMdm" />
        </div>

        <!-- 2. Message Template Settings (Approver Only) -->
        <div v-else-if="currentTab === 'settings' && canApproveMdm" class="animated fadeIn">
            <MdmSettingsSection :is-approver="canApproveMdm" />
        </div>

        <!-- 3. Dynamic Approval Engine (Warning, Lock, Unlock) -->
        <div v-else class="animated fadeIn">
            <MdmApprovalTable 
                :current-tab="currentTab"
                :is-requester="canRequestMdm"
                :is-approver="canApproveMdm"
                :auto-open-batch-id="$route.query.open_batch_id"
            />
        </div>
    </div>

  </Layout>
</template>

<style scoped>
.animated { animation-duration: 0.3s; }
.fadeIn { animation-name: fadeIn; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
</style>
